export default "__VITE_ASSET__CyAXgk$j__"